function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 53.0004,
  cy: 53.5,
  r: 53,
  fill: "#F0F8FC"
});
var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_7343_11497)"
}, React.createElement("path", {
  d: "M53.562 51.3018C53.6541 51.6358 53.913 51.8988 54.2455 51.9961L71.7993 57.1318L54.227 62.6387C53.9449 62.7271 53.7184 62.9346 53.6049 63.2031L53.5639 63.3213L48.8803 79.9424L43.8227 63.3018C43.7396 63.0286 43.5448 62.8058 43.2895 62.6865L43.1772 62.6426L26.3188 57.1318L43.1586 51.9922C43.479 51.8942 43.7291 51.6424 43.8246 51.3213L48.8803 34.3271L53.562 51.3018Z",
  stroke: "#005C81",
  strokeWidth: 2,
  strokeLinejoin: "round"
}), React.createElement("path", {
  d: "M71.1699 34.4307C71.2621 34.7645 71.5211 35.0268 71.8535 35.124L79.5508 37.376L71.835 39.7949C71.5529 39.8834 71.3264 40.0909 71.2129 40.3594L71.1719 40.4775L69.1562 47.6299L66.9766 40.458C66.8817 40.1459 66.6402 39.8992 66.3301 39.7979L58.9209 37.376L66.3115 35.1211C66.6322 35.0232 66.8829 34.7706 66.9785 34.4492L69.1562 27.1289L71.1699 34.4307Z",
  stroke: "#005C81",
  strokeWidth: 2,
  strokeLinejoin: "round"
}));
var _ref3 = /*#__PURE__*/React.createElement("defs", null, React.createElement("clipPath", {
  id: "clip0_7343_11497"
}, React.createElement("rect", {
  width: 60,
  height: 60,
  fill: "white",
  transform: "translate(23.0004 23.5)"
})));
var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 106,
    height: 107,
    viewBox: "0 0 106 107",
    fill: "none"
  }, props), _ref, _ref2, _ref3);
};
export default __webpack_public_path__ + "static/media/AISuggestion.37a615b6.svg";
export { SvgComponent as ReactComponent };